import { takeLatest } from 'redux-saga/effects';

import { appManagementActionTypes } from '@/redux/actions';
import apiConfig from '@/constants/apiConfig';

import { processCallbackAction } from '../helper';

const {
    GET_LIST,
    GET_DETAIL,
    CREATE,
    UPDATE,
    UPDATE_STATUS,
    RENEW_CLIENT_APP_ID,
    RENEW_SECRET_KEY,
} = appManagementActionTypes;

const getList = (action) => {
    return processCallbackAction(apiConfig.clientApp.getList, action);
}

const getDetail = ({payload}) => {
    const {params, onCompleted, onError} = payload;
    const apiOptions = {
        ...apiConfig.clientApp.getDetail,
        path: apiConfig.clientApp.getDetail.path.replace(':id', params.id)
    }
    return processCallbackAction(apiOptions, {payload: {params: {}, onCompleted, onError}});
}

const create = (action) => {
    return processCallbackAction(apiConfig.clientApp.create, action);
}

const update = (action) => {
    return processCallbackAction(apiConfig.clientApp.update, action);
}

const updateStatus = (action) => {
    return processCallbackAction(apiConfig.clientApp.updateStatus, action);
}

const renewClientAppId = ({payload}) => {
    const {params, onCompleted, onError} = payload;
    const apiOptions = {
        ...apiConfig.clientApp.renewClientAppId,
        path: apiConfig.clientApp.renewClientAppId.path.replace(':id', params.id)
    }
    return processCallbackAction(apiOptions, {payload: {params: {}, onCompleted, onError}});
}

const renewSecretKey = ({payload}) => {
    const {params, onCompleted, onError} = payload;
    const apiOptions = {
        ...apiConfig.clientApp.renewSecretId,
        path: apiConfig.clientApp.renewSecretId.path.replace(':id', params.id)
    }
    return processCallbackAction(apiOptions, {payload: {params: {}, onCompleted, onError}});
}


const adminSagas = [
    takeLatest(GET_LIST, getList),
    takeLatest(CREATE, create),
    takeLatest(GET_DETAIL, getDetail),
    takeLatest(UPDATE, update),
    takeLatest(UPDATE_STATUS, updateStatus),
    takeLatest(RENEW_CLIENT_APP_ID, renewClientAppId),
    takeLatest(RENEW_SECRET_KEY, renewSecretKey),
];

export default adminSagas;